<emma-modal [loading]="loading" (close)="onCloseButton()" size="md" [noFooter]="false">
    <ng-container class="emma-modal-title">
        <i class="la la-image" aria-hidden="true"></i>
        <span i18n>Insertar imagen desde URL</span>
    </ng-container>
    <ng-container class="emma-modal-body">
        <div class="row">
            <div class="col-md-12">
                <div
                    emma-label
                    label="URL de la imagen"
                    helpText=""
                    helpLink="https://docs.emma.io/"
                    i18n-label
                    i18n-helpText
                >
                    <emma-input
                        #srcInput
                        required="true"
                        type="url"
                        [isWeburl]="true"
                        [(ngModel)]="src"
                        [autofocus]="true"
                    ></emma-input>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container class="emma-modal-footer">
        <button emmaButton [loading]="loading" color="cancel" (click)="onCloseButton()" i18n>Cancelar</button>
        <button
            emmaButton
            [loading]="loading"
            color="brand"
            [isWide]="true"
            [disabled]="!src"
            (click)="onInsertImageButton()"
            i18n
        >
            Insertar imagen
        </button>
    </ng-container>
</emma-modal>
